import logoImage from '@/assets/images/logo-cour-des-comptes.png'

export const MOBILE_LOGO_PROPS = {
  src: logoImage,
  alt: "Logo Cour des Comptes",
  screen_size: {
    mobile_s: 250,
    mobile_m: 250,
    mobile_l: 250,
    tablet: 250,
    laptop: 60,
    laptop_l: 60,
    desktop: 60,
    k_screen: 60,
  },
  className: "rounded-md w-full object-cover",
}
